export enum DeviceSizes {
  mobile,
  largeMobile,
  tablet,
  smallLaptop,
  laptop,
  largeLaptop,
  large,
  huge,
  unknown
}
